"use client";

import { motion, useReducedMotion } from "framer-motion";
export default function Consultancy() {
  const prefersReducedMotion = useReducedMotion();
  const principles = [{
    numeral: "I.",
    kicker: "ACCESS",
    title: "Direct expert access.",
    body: "You work with me, not a junior account manager. Every strategy, audit, and implementation is handled personally by me, ensuring my full expertise is applied to your business goals without the dilution of agency layers.",
    variant: "soft" as const
  }, {
    numeral: "II.",
    kicker: "STRATEGY",
    title: "Tailored SEO growth.",
    body: "I reject cookie-cutter templates. My approach is built on deep analysis of your specific market, audience, and technical landscape, creating a bespoke roadmap designed for sustainable, long-term search visibility.",
    variant: "accent" as const
  }, {
    numeral: "III.",
    kicker: "RESULTS",
    title: "Transparent impact.",
    body: "I focus on metrics that drive business growth, not vanity rankings. My reporting is clear, honest, and tied directly to your bottom line, providing you with full visibility into the value of our SEO partnership.",
    variant: "soft" as const
  }];
  const cardInitial = prefersReducedMotion ? {
    opacity: 1,
    y: 0
  } : {
    opacity: 0,
    y: 32
  };
  const cardAnimate = {
    opacity: 1,
    y: 0
  };
  return <section data-section-id="23034" id="miltonkeynesmarketanalysis" data-nav="light" className="relative bg-background text-foreground py-28 md:py-40">
      <div className="mx-auto w-full max-w-[1440px] px-6 sm:px-10 lg:px-20">
        <div className="w-full h-px bg-border mb-16 md:mb-20" />

        <div className="grid grid-cols-1 md:grid-cols-12 md:gap-8">
          <div className="md:col-span-2 mb-6 md:mb-0">
            <span className="font-sans text-[0.875rem] font-medium uppercase text-foreground" style={{
            letterSpacing: "0.16em"
          }}>
              MY CONSULTANCY
            </span>
          </div>
          <div className="md:col-span-10">
            <h1 className="font-serif text-foreground" style={{
            fontWeight: 360,
            fontSize: "clamp(1.75rem, 2.8vw, 2.375rem)",
            letterSpacing: "-0.028em",
            lineHeight: "0.96"
          }}>
              Three pillars.{" "}
              <span className="italic relative inline-block" style={{
              fontWeight: 340
            }}>
                One
                <svg className="absolute left-0 right-0 -bottom-1 md:-bottom-2 w-full pointer-events-none" viewBox="0 0 120 12" preserveAspectRatio="none" aria-hidden="true" style={{
                height: "0.35em"
              }}>
                  <motion.path d="M2 7 Q 30 2, 60 6 T 118 5" stroke="var(--accent)" strokeWidth="4" strokeLinecap="round" fill="none" initial={prefersReducedMotion ? {
                  pathLength: 1
                } : {
                  pathLength: 0
                }} whileInView={{
                  pathLength: 1
                }} viewport={{
                  once: true,
                  amount: 0.6
                }} transition={{
                  duration: 0.7,
                  delay: 0.5,
                  ease: [0.65, 0, 0.35, 1]
                }} />
                </svg>
              </span>{" "}
              commitment.
            </h1>
          </div>
        </div>

        <div className="mt-16 md:mt-[72px] grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {principles.map((p, i) => {
          const isAccent = p.variant === "accent";
          return <motion.div key={i} data-index={i} initial={cardInitial} whileInView={cardAnimate} viewport={{
            once: true,
            amount: 0.25
          }} transition={{
            duration: 0.72,
            delay: prefersReducedMotion ? 0 : i * 0.12,
            ease: [0.22, 1, 0.36, 1]
          }} whileHover={prefersReducedMotion ? undefined : {
            filter: "brightness(1.02)"
          }} className={`group relative flex flex-col p-10 md:p-12 min-h-[480px] transition-all duration-[320ms] ${isAccent ? "text-accent-foreground" : "text-foreground hover:brightness-[1.02]"}`} style={{
            borderRadius: "28px",
            backgroundColor: isAccent ? "var(--primary)" : "var(--card)"
          }}>
                <div className="font-serif italic transition-transform duration-[320ms] ease-out group-hover:translate-x-[2px]" style={{
              fontWeight: 300,
              fontSize: "clamp(4.5rem, 9vw, 7.875rem)",
              letterSpacing: "-0.04em",
              lineHeight: "0.85",
              color: isAccent ? "var(--primary-foreground)" : "var(--muted-foreground)"
            }}>
                  {p.numeral}
                </div>

                <div className="mt-6">
                  <span className="font-sans font-medium uppercase" style={{
                fontSize: "0.875rem",
                letterSpacing: "0.16em",
                color: isAccent ? "var(--primary-foreground)" : "var(--foreground)"
              }}>
                    {p.kicker}
                  </span>
                </div>

                <h3 className="font-serif mt-5" style={{
              fontWeight: 400,
              fontSize: "clamp(1.375rem, 1.8vw, 1.625rem)",
              letterSpacing: "-0.02em",
              lineHeight: "1.05"
            }}>
                  {p.title}
                </h3>

                <p className="font-sans mt-5" style={{
              fontSize: "1.0625rem",
              lineHeight: "1.6",
              color: isAccent ? "var(--primary-foreground)" : "var(--muted-foreground)"
            }}>
                  {p.body}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}